import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, Validators,FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { APIIPRegisterService } from '../../_services/ip-register/API-ipregister';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';

let now = new Date();

@Component({
  selector: 'app-ip-registration',
  templateUrl: './ip-registration.component.html',
  styleUrls: ['./ip-registration.component.css']
})
export class IpRegistrationComponent implements OnInit {
  ipRegistrationForm: FormGroup;
  response: any
  dataSource: any;
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['srNo', 'ipAddress', 'RegisterDate', 'Remove'];

  UpdateFlag:boolean = false
  EntityID: any
  EntityName: any
  callBackURL: any;
  entityToken: any;
  previouscallbackvalue: any;
  enableRegisterbTN: boolean
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();



  constructor(private fb: FormBuilder,

    private ip: APIIPRegisterService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,

  ) {

    this.EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    this.EntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME)
    this.callBackURL = this.db.get(Constants.SESSSION_STORAGE, Constants.CALLBACKURL)
    this.entityToken = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_TOKEN);

  }

  ngOnInit() {
    this.ipRegistrationForm = this.fb.group({

      entityID: [''], //To allow from 15 to 19 digits

      entityName: [''],
      callBackURL: [''],
      token: [''],
      // ipAddress: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,5}$')]],

      ipAddress: ['', [Validators.required,this.validateIpInput]]
    },{
	   //   validator: this.validateIpInput('ipAddress')

	});

    //ipv6: const regexExp = /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/gi;
    //https://stackoverflow.com/questions/46100911/allow-to-accept-multiple-validator-patterns-in-angular-material-2

    this.ipRegistrationForm.controls['entityID'].setValue(this.EntityID);

    this.ipRegistrationForm.controls['entityName'].setValue(this.EntityName);
    this.ipRegistrationForm.controls['callBackURL'].setValue(this.callBackURL);
    this.ipRegistrationForm.controls['token'].setValue(this.entityToken)
    // console.log(" this.entityToken========", this.entityToken)
    this.getListIPAddress();
	//this.validateIpInput();
  }


  get f() { return this.ipRegistrationForm.controls; }

  async onSubmit() {
    if (this.ipRegistrationForm.invalid) {
      return;
    }
    else {

      var data = {
        EntityID: this.ipRegistrationForm.get("entityID").value,
        IP_Address: this.ipRegistrationForm.get("ipAddress").value,
        Entity_Name: this.ipRegistrationForm.get("entityName").value,
        Created_By: this.ipRegistrationForm.get("entityID").value
      }
      await this.ip.addNewIP(data)
        .subscribe(r => {
          if (r.Status == "Ok") {
            this.$modal.successModal({
              title: 'IP Registration',
              msg: 'IP Registered successfully'
            });
            setTimeout(() => {
              this.getListIPAddress();
            }, 500)

          }
          else {
            this.$modal.errorModal({
              title: 'IP Registration',
              msg: r.Err
            //  msg: 'Error while adding IP ' + r.Err
            });

          }
        })


    }

  }

  removeIP(entityID, URN) {

    var data = {
      EntityID: entityID,
      URN: URN
    }
    this.ip.removeIP(data)
      .subscribe(r => {
        console.log("response is : ", r)

        if (r.Status == "Ok") {
          this.$modal.successModal({
            title: 'IP Registration',
            msg: 'IP has been removed successfully'
          });
          setTimeout(() => {
            this.getListIPAddress();
          }, 500)
        }
        else {
          this.$modal.errorModal({
            title: 'IP Registration',
            msg: 'Error while removing IP ' + r.Err
          });

        }
      })



  }

  downloadIPcsvfile() {
    var data = {
      EntityID: this.EntityID
    }

    var fileName;
    const currentdate = formatDate(now, 'medium', 'en-US', '+0530');
    this.ip.exportCSV(data).subscribe(r => {
      fileName = currentdate + this.EntityID + '_IP.csv';
      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'IP Registration',
        msg: 'File has been downloaded Successfully'
      });
    })

  }


  getListIPAddress() {
    var data = {
      EntityID: this.EntityID
    }
    this.ip.listIPAddress(data)
      .subscribe({
        next: response => {
          this.ipRegistrationForm.controls['callBackURL'].setValue(response.callback);
          this.previouscallbackvalue=response.callback
          if(response.callback== null || response.callback ==""){
            this.enableRegisterbTN = true
            }
            else{
              this.enableRegisterbTN =false
            }
          this.dataSubject.next(response.Values);
          this.dataSource = new MatTableDataSource();

          this.dataSource = new MatTableDataSource(response.Values);
          this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
        }
      });

  }
  
  
   validateIpInput(c: FormControl) {
	   
	   
	   console.log("c",c)
   // let  Ipv4= /(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?) /; // Regular Expression 1 for IPv4
   
   let Ipv4 = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/
let  Ipv6=/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/gi;	  


	   console.log("c.value is ",c.value)
	   console.log("Ipv4.test(c.value)",Ipv4.test(c.value))
	   console.log("Ipv6.test(c.value)",Ipv6.test(c.value))
	   
	   var returnedValue = (Ipv4.test(c.value) || Ipv6.test(c.value)) ? null : {
      validateIpInput: {
      valid: false
      }
	   }
		console.log("returned value is ",returnedValue)

     return (Ipv4.test(c.value) || Ipv6.test(c.value)) ? null : {
      validateIpInput: {
      valid: false
      }
    };
 
  }
		//Usage
			/* sampleFormControl = new FormControl('', [
			validateIpInput
	 ]);
*/

registerCallbackURL() {
  var input = this.ipRegistrationForm.get("callBackURL").value
  if(input==this.previouscallbackvalue)
  {
    this.$modal.errorModal({
      title: 'Callback URL',
      msg: 'please change the Callback URL'
    });
    return
  }
  var data = {
    EntityID: this.ipRegistrationForm.get("entityID").value,
    CallbackURL: this.ipRegistrationForm.get("callBackURL").value,
  }
  if(input == null || input =="")
  {
    this.$modal.errorModal({
      title: 'Callback URL',
      msg: 'please enter url'
    });
  }
  else{
  this.ip.addNewURL(data)
    .subscribe(r => {
      if (r.Status == "Ok") {
        this.enableRegisterbTN = false;
        this.disableControles();
        this.previouscallbackvalue=input;
        this.$modal.successModal({
          title: 'Callback URL',
          msg: 'Registered successfully'
        });
        this.disableControles();
      }
      else {
        this.$modal.errorModal({
          title: 'Callback URL',
          msg:  r.Err
        });
     
      }
    })
  }
}

enableControles() {
  this.ipRegistrationForm.controls['callBackURL'].enable();
}

disableControles() {
  this.ipRegistrationForm.controls['callBackURL'].disable();
}

EditCallback(){
  this.enableControles();
  this.UpdateFlag=true;
}
updatedCallbackURL() {
  var input=this.ipRegistrationForm.get("callBackURL").value;
  if(input==this.previouscallbackvalue)
  {
    this.$modal.errorModal({
      title: 'Callback URL',
      msg: 'please Modify the URL before clicking on Update'
    });
    return
  }
  var data = {
    EntityID: this.ipRegistrationForm.get("entityID").value,
    CallbackURL: this.ipRegistrationForm.get("callBackURL").value,
  }
  
  this.ip.updatedURL(data)
    .subscribe(r => {
      this.enableControles();
      if (r.Status == "Ok") {
        this.enableRegisterbTN = false;
        this.UpdateFlag= false;
        this.previouscallbackvalue=input;
        this.$modal.successModal({
          title: 'Callback URL',
          msg: 'updated successfully'
        });
        this.disableControles();
      }
      else {
        this.$modal.errorModal({
          title: 'Callback URL',
          msg:  r.Err
        });
        this.disableControles();
      }
    })


}

generateToken() {
  let data = {
    peid : this.EntityID
  }
  this.ip.generateTokenForEntity(data)
    .subscribe(r => {
      if(r.status = 'success') {
       this.ipRegistrationForm.controls['token'].setValue(r.message)
      }
    })
}

}